<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3IhMrY/tc-custom/9780292742796.jpg?1704761281380" alt="This image is the cover for the book Dwight Yoakam, American Music Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dwight Yoakam, American Music Series
      </h1>
      <p class="bookDescription body article font2">
        <b>“[A] </b><b>compulsively readable biography . . . Essential for fans of Yoakam and lovers of good music writing.” ―<i>Library Journal</i> </b><br/>  <br/> From his formative years playing pure hardcore honky-tonk for mid-’80s Los Angeles punk rockers through his subsequent surge to the top of the country charts, Dwight Yoakam has enjoyed a singular career. An electrifying live performer, superb writer, and virtuosic vocalist, he’s successfully bridged two musical worlds that usually have little use for each other: commercial country and its alternative/Americana/roots-rocking counterpart. Defying the label “too country for rock, too rock for country,” Yoakam has triumphed while many of his peers have had to settle for cult acceptance. Four decades into his career, he’s sold more than twenty-five million records and continues to tour regularly.<br/><br/> Now award-winning music journalist Don McLeese offers the first musical biography of this acclaimed artist. Tracing the seemingly disparate influences in Yoakam’s music, McLeese shows how he’s combined rock and roll, rockabilly, country, blues, and gospel into a seamless whole. In particular, McLeese explores the essential issue of “authenticity” and how it applies to Yoakam, as well as to country music and popular culture in general.<br/>  <br/> Drawing on wide-ranging interviews with Yoakam and his management, while also benefiting from the perspectives of others closely associated with his success (including producer-guitarist Pete Anderson, partner throughout Yoakam’s most popular and creative decades), <i>Dwight Yoakam</i> pays tribute to the musician who has established himself as a visionary beyond time, an artist who could title an album <i>Tomorrow’s Sounds Today</i> and deliver it.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Don McLeese
      </h2>
      
      <p class="authorDescription body article">Don McLeese was formerly the pop music critic for the Chicago Sun-Times and the Austin American-Statesman, as well as country columnist and frequent contributor to Rolling Stone and a senior editor for No Depression. He has chronicled Dwight Yoakam in reviews, features, and interviews from the beginning of the artist’s recording career through the present day. He currently teaches journalism at the University of Iowa. His most recent book is The New York Times Reader: Arts and Culture.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University Of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?06500a3c